export function Skeleton(props: { name?: string }) {
  performance.mark('fcp')
  return (
    <>
      <div className='loading__sidebar'>
        <div className='loading_skel_1' style={{ fontWeight: 400 }}>
          {props.name}
        </div>
        <div className='loading_skel_2' />
        <div className='loading_skel_2' />
        <div className='loading_skel_2' />
        <div className='loading_skel_3' />
        <div className='loading_skel_3' />
        <div className='loading_skel_3' />
        <div className='loading_skel_3' />
        <div className='loading_skel_2' />
        <div className='loading_skel_3' />
        <div className='loading_skel_3' />
        <div className='loading_skel_2' />
      </div>
      <div className='loading__maincontent' />
    </>
  )
}
